import React from "react";
import { Icon } from "./Icon";

export default function Logo() {
  return <Icon color="white" />;
}
